module.exports = __webpack_public_path__ + "img/carrito.781f3a98.svg";